import { useState } from "react";
import { LuCheckCircle2, LuAlertCircle } from "react-icons/lu";
import { authFetch } from "../../utils/api";

const EMPTY_FORM = { firstName: "", lastName: "", email: "", password: "", role: "contributor" };


//CRÉATION DES COMPTES DU BACK OFFICE (réservée aux administrateurs)
function ManageAccounts() {

  const [form, setForm] = useState(EMPTY_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null); // { type, texts }

  const updateField = (field, value) => setForm((previous) => ({ ...previous, [field]: value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setMessage(null);
    try {
      const response = await authFetch("/authRoute/createAccount", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          firstNameFromFront: form.firstName.trim(),
          lastNameFromFront: form.lastName.trim(),
          emailFromFront: form.email.trim(),
          passwordFromFront: form.password,
          roleFromFront: form.role,
        }),
      });
      const body = await response.json();
      if (body.result === true) {
        setForm(EMPTY_FORM);
        setMessage({ type: "success", texts: body.success });
      } else {
        setMessage({ type: "error", texts: body.error });
      }
    } catch (error) {
      setMessage({ type: "error", texts: ["Le compte n’a pas pu être créé. Merci de réessayer."] });
    }
    setIsSubmitting(false);
  };

  return (
    <div className="bo-page surface">
      <h2 className="title-xl bo-page_title">Créer un compte</h2>
      <p className="bo-page_intro">Les contributeurs gèrent les événements et les flash news. Les administrateurs peuvent en plus créer des comptes.</p>

      <form onSubmit={handleSubmit} noValidate>
        <fieldset className="form-section">
          <legend className="form-section_title">Nouveau compte</legend>

          <div className="field_row">
            <div className="field">
              <label className="field_label" htmlFor="accountFirstName">Prénom <span className="field_required">*</span></label>
              <input className="field_control" id="accountFirstName" type="text" autoComplete="off" value={form.firstName} onChange={(e) => updateField("firstName", e.target.value)} />
            </div>
            <div className="field">
              <label className="field_label" htmlFor="accountLastName">Nom <span className="field_required">*</span></label>
              <input className="field_control" id="accountLastName" type="text" autoComplete="off" value={form.lastName} onChange={(e) => updateField("lastName", e.target.value)} />
            </div>
          </div>

          <div className="field_row">
            <div className="field">
              <label className="field_label" htmlFor="accountEmail">E-mail <span className="field_required">*</span></label>
              <input className="field_control" id="accountEmail" type="email" autoComplete="off" value={form.email} onChange={(e) => updateField("email", e.target.value)} />
            </div>
            <div className="field">
              <label className="field_label" htmlFor="accountPassword">Mot de passe provisoire <span className="field_required">*</span></label>
              <input className="field_control" id="accountPassword" type="text" autoComplete="new-password" value={form.password} onChange={(e) => updateField("password", e.target.value)} />
              <p className="field_hint">8 caractères minimum. À transmettre à la personne concernée.</p>
            </div>
          </div>

          <div className="field">
            <span className="field_label">Rôle <span className="field_required">*</span></span>
            <label className="check">
              <input className="check_box" type="radio" name="accountRole" value="contributor" checked={form.role === "contributor"} onChange={() => updateField("role", "contributor")} />
              <span className="check_text">
                <strong>Contributeur</strong>
                <span>Crée et modifie les événements et les flash news.</span>
              </span>
            </label>
            <label className="check">
              <input className="check_box" type="radio" name="accountRole" value="administrator" checked={form.role === "administrator"} onChange={() => updateField("role", "administrator")} />
              <span className="check_text">
                <strong>Administrateur</strong>
                <span>Comme un contributeur, et peut aussi créer des comptes.</span>
              </span>
            </label>
          </div>
        </fieldset>

        {message && (
          <div className={`msg ${message.type === "success" ? "msg--success" : "msg--error"} form_message`} role={message.type === "success" ? "status" : "alert"}>
            {message.type === "success" ? <LuCheckCircle2 aria-hidden="true" /> : <LuAlertCircle aria-hidden="true" />}
            <div>{message.texts.map((text) => <p key={text}>{text}</p>)}</div>
          </div>
        )}

        <div className="form-actions">
          <button type="submit" className="btn btn--primary btn--lg" disabled={isSubmitting}>
            {isSubmitting ? "Création…" : "Créer le compte"}
          </button>
        </div>
      </form>
    </div>
  )
};

export default ManageAccounts;
